import { useQuery } from "@tanstack/react-query";
import CommonService from "../services/CommonService";

export const usePortCodes = () => {
    return useQuery({
        queryKey: ["portCodes"],
        queryFn: () => CommonService.getAllPortCodes().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};